import { ErrorType } from "../../models/HttpError";

export interface ProtocolPatientsState {
    isLoading: boolean;
    isGeneratedSuccessfully: boolean;
    failOnGenerating: boolean;
    error: ErrorType | null;
    excelBlob: Blob | null;
}

export const ProtocolPatientsUnloadState: ProtocolPatientsState = {
    isLoading: false,
    isGeneratedSuccessfully: false,
    failOnGenerating: false,
    error: null,
    excelBlob: null
};
